<app-spinner [loading]="isCreating"></app-spinner>
<app-copy-crypto-token-key
    [value]="value"
    [aliasSuffix]="aliasSuffix"
    (copiedValue)="onCopy($event)"
    (copyCanceled)="onCancel()"
  >
</app-copy-crypto-token-key>
